<template>
  <div style="width: 100%;height: 100%">
    <div ref="videoContainer" :id="'videoContainer' + id" style="width: 100%;height: 100%"></div>
  </div>
</template>

<script>
import eZuiKit from '../../../../static/ysy/ezuikit'
export default {
  name: 'ysyVideo',
  props: {
    videoObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      player: null,
      id: 0,
      widthBox: 0,
      heightBox: 0
    }
  },
  mounted () {
    // console.log('获取父盒子宽高', this.$refs.videoContainer.offsetWidth, this.$refs.videoContainer.offsetHeight)
    let width = this.$refs.videoContainer.offsetWidth
    let height = this.$refs.videoContainer.offsetHeight
    console.log(width, height)
    this.widthBox = width
    this.heightBox = height
    this.startVideo(this.videoObj)
  },
  beforeDestroy () {
    if (this.player) {
      this.closeVideo()
    }
  },
  created () {
  },
  methods: {
    startVideo (videoObj) {
      let that = this
      this.id = videoObj.id
      this.player = new eZuiKit.EZUIKitPlayer({
        id: 'videoContainer' + that.id,
        autoplay: true,
        url: videoObj.url,
        accessToken: videoObj.accessToken,
        handleSuccess: that.handleSuccess(),
        template: 'pcLive',
        width: that.widthBox,
        height: that.heightBox
        // header: [],
        // footer: ['play', 'sound', 'hd', 'expend']
      })
    },
    closeVideo () {
      if (this.player) {
        this.player.stop()
      }
    },

    handleSuccess () {
      this.$emit('startSuccess')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/videoComponent/components/ysyVideo.vue